/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import React from 'react';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { TitleCase } from '../../../../redux/helper/CamelCase';

export default function CategoryManager({
    Filters, handleCheckBox, Segments, checkBox,
}) {
    const FilterTree = (items) => Object.keys(items).map((property, index) => (
        <div key={items[property].concatenated_segment} className="relative">
            {property !== 'concatenated_segment' && property !== '' && (
                <button className="pl-6 pt-3 categories transition duration-150 ease-in-out flex items-center drop-rotate" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat1" aria-expanded="false" aria-controls="collapsecat1" style={{ cursor: 'pointer' }}>
                    <div className="cursor-pointer relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                        <Checkbox
                            icon={
                                <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${checkBox.includes(items[property].concatenated_segment) ? '#555259' : ''}` }} />
                            }
                            name="my-input"
                            className="cursor-pointer"
                            checked={checkBox.includes(items[property].concatenated_segment)}
                            onChange={(value, event) => {
                                event.preventDefault();
                                handleCheckBox(items[property].concatenated_segment);
                            }}
                            borderColor={`${!checkBox.includes(items[property].concatenated_segment) ? '#B8C5DC' : '#555259'}`}
                            style={{ cursor: 'pointer' }}
                            labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                        />
                        <label
                            htmlFor={`${property}-${index}`}
                            className={`pl-3 text-sm cursor-pointer ${checkBox.includes(items[property].concatenated_segment) ? 'text-[#555259] font-bold' : 'text-[#808285] font-normal'}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleCheckBox(items[property].concatenated_segment, 'segments');
                            }}
                        >
                            {TitleCase(property)}

                        </label>
                    </div>
                    {Object.keys(items[property]).length > 1
                    && (
                        <img
                            onClick={(e) => {
                                e.preventDefault();
                                handleCheckBox(items[property].concatenated_segment, 'segments');
                            }}
                            src="/images/Arrow_down.svg"
                            alt="icon"
                            className={`ml-1.5 drop-btn ${Segments?.includes(items[property].concatenated_segment) ? 'show image-rotate' : ''}`}
                        />
                    )}
                </button>
            )}
            {Object.keys(items[property]).length > 0 && property !== 'concatenated_segment' && (
                <div
                    className={`collapse ${Segments?.includes(items[property].concatenated_segment) ? 'show' : 'hidden'} pl-6 pt-3 flex flex-col`}
                    id="collapsecat1"
                >
                    {FilterTree(items[property])}

                </div>
            )}
        </div>
    ));
    return (
        <div>{FilterTree(Filters)}</div>
    );
}
